import {
    GetPlanList,
    DeletePlan,
    GetPlanModules,
    UpdateModule,
    CreatePlan,
    GetPlan,
    UpdatePlan,
} from '@src/services/plan'
// import Vue from 'vue'
// import { ProfileGet } from '@src/services/utils'
// import { getSavedState } from '@src/utils/localStorage'
export const state = {
    planList: [],
    planModules: [],
}

export const getters = {
    totalList(state) {
        return state.planList.data ? state.planList.data.totalItemCount : 0
    },
    computedList(state) {
        if (state.planList.data) {
            return state.planList.data.items.map((plan) => plan)
        }
        return []
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.planList = newList
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((team) => {
            state.planList.data.items.push(team)
        })
    },
    SET_PLAN_MODULES(state, newList) {
        state.planModules = newList
    },
    SET_MODULE_PERMISSION(state, newList) {
        state.planModules.items.forEach((planModule) => {
            newList.forEach(({ modulePublicId }) => {
                // Ir para o mesmo módulo
                if (planModule.modulePublicId === modulePublicId) {
                    planModule.permissions.forEach((permissionModule) => {
                        newList.forEach((itemList) => {
                            // Verificar mesmo role e mesma action para fazer a mudança
                            if (
                                permissionModule.rolePublicId ===
                                    itemList.rolePublicId &&
                                permissionModule.permissionTypePublicId ===
                                    itemList.permissionTypePublicId
                            ) {
                                permissionModule.allowed = itemList.allowed
                            }
                        })
                    })
                }
            })
        })
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const resp = await GetPlanList(parameters)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
        return resp
    },
    async nextPage({ commit }, currentPage) {
        const resp = await GetPlanList(currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
    async deletePlan({ dispatch }, publicId) {
        const resp = await DeletePlan(publicId)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async fetchModules({ commit }, planPublicId) {
        const resp = await GetPlanModules(planPublicId)
        if (resp.status === 200) {
            commit('SET_PLAN_MODULES', resp.data.data)
        }
        return resp
    },
    async updateModulePermission({ commit }, permissionModule) {
        const resp = await UpdateModule(permissionModule)
        if (resp.status === 200) {
            commit('SET_MODULE_PERMISSION', permissionModule)
        }
        return resp
    },
    async createPlan(_, plan) {
        const resp = await CreatePlan(plan)
        return resp
    },
    async getPlanInfo(_, planPublicId) {
        const resp = await GetPlan(planPublicId)
        return resp
    },
    async updatePlan(_, plan) {
        const resp = await UpdatePlan(plan)
        return resp
    },
}
